import React, { useState } from 'react';
import EditBar from 'modules/subscription-settings/container/EditBar';
import Header from 'partial/Header';
import Sidebar from 'partial/Sidebar';
import ModuleWrapper, { ModuleLabel } from 'partial/wrappers/ModuleWrapper';
import { Outlet, Route, Routes } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { PlansProvider } from './wrappers/PlansContext';

function Layout() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <ModuleWrapper>
      <PlansProvider>
        <div>
          <Header isOpen={isOpen} setIsOpen={setIsOpen} />
          <div className="h-[calc(100vh_-_90px)] flex overflow-hidden bg-light-gray-50">
            <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
            <Scrollbars autoHide>
              <main className="flex-1 relative overflow-y-auto focus:outline-none flex flex-col z-10">
                <div className="w-full p-8 flex flex-col">
                  <ModuleLabel />
                  <div className="flex-auto my-2">
                    <Outlet />
                  </div>
                </div>
              </main>
            </Scrollbars>
          </div>
          <Routes>
            <Route
              path="/settings/plans/:planId/update-plan"
              element={<EditBar />}
            />
          </Routes>
        </div>
      </PlansProvider>
    </ModuleWrapper>
  );
}

export default Layout;
